import { z } from 'zod';

/** Operations-ID des Clients: macht Wiederholungen nach Netzfehlern idempotent (Leitlinie, Seite 6). */
export const opIdSchema = z.string().min(8).max(64).regex(/^[A-Za-z0-9_-]+$/);
export const uuidSchema = z.uuid();
export const nameSchema = z.string().trim().min(1).max(120);
export const emailSchema = z.email().trim().toLowerCase().max(254);

/**
 * PATCH-Schemas immer hierüber bauen, nie mit `.partial()` (aus KaBa übernommen): zod 4 setzt Defaults
 * sonst auch bei fehlenden Feldern und überschreibt damit Werte, die gar nicht übergeben wurden.
 */
export function patchOf<T extends z.ZodRawShape>(shape: T) {
  const optional = Object.fromEntries(Object.entries(shape).map(([k, v]) => [k, (v as z.ZodType).optional()])) as unknown as {
    [K in keyof T]: z.ZodOptional<T[K]>;
  };
  return z
    .object(optional)
    .strict()
    .refine((o) => Object.values(o).some((v) => v !== undefined), { message: 'Keine Änderung übergeben' });
}
